module.exports = __webpack_public_path__ + "static/assets/9918a0206cbd34617d1e61ca58357076.png";